"use strict";

exports.__esModule = true;
exports.Flex = void 0;

var _styled = require("@manifest-ui/styled");

const Flex = (0, _styled.styled)('div', {
  label: 'Flex',
  themeKey: 'flex'
})(({
  align,
  basis,
  direction,
  grow,
  justify,
  shrink,
  wrap
}) => ({
  alignItems: align,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: direction,
  flexWrap: wrap,
  flexBasis: basis,
  flexGrow: grow,
  flexShrink: shrink,
  justifyContent: justify
}));
exports.Flex = Flex;
Flex.displayName = 'Flex';